(function () {
	const desktopMediaQuery = window.matchMedia('(min-width: 782px)');
	const innerSubmenuAimSettings = {
		openDelay: 80,
		switchDelay: 120,
		protectedSwitchDelay: 220,
		closeDelay: 160,
		corridorPadding: 16,
	};

	function getMenuKey(classList, prefix) {
		return Array.from(classList).find((className) => className.startsWith(prefix))?.slice(prefix.length) || null;
	}

	function initInnerSubmenuAim(wrapper) {
		const innerSubmenuItems = Array.from(wrapper.querySelectorAll('.mega-menu .wp-block-navigation-item.has-child')).reduce(function (items, item) {
			const toggle = item.querySelector(':scope > .wp-block-navigation-submenu__toggle');
			const submenu = item.querySelector(':scope > .wp-block-navigation__submenu-container.wp-block-navigation-submenu');
			const panel = item.closest('.mega-menu');

			if (!toggle || !submenu || !panel) {
				return items;
			}

			items.push({ item, toggle, submenu, panel });
			return items;
		}, []);

		if (!innerSubmenuItems.length) {
			return function () {};
		}

		const innerSubmenuMap = new Map(innerSubmenuItems.map(function (entry) {
			return [entry.item, entry];
		}));

		let activeInnerItem = null;
		let pendingInnerItem = null;
		let previousPointerPosition = null;
		let currentPointerPosition = null;
		let openTimerId = 0;
		let switchTimerId = 0;
		let closeTimerId = 0;

		function clearTimer(timerId) {
			if (!timerId) {
				return 0;
			}

			window.clearTimeout(timerId);
			return 0;
		}

		function clearPendingTimers() {
			openTimerId = clearTimer(openTimerId);
			switchTimerId = clearTimer(switchTimerId);
			pendingInnerItem = null;
		}

		function clearCloseTimer() {
			closeTimerId = clearTimer(closeTimerId);
		}

		function clearAllTimers() {
			clearPendingTimers();
			clearCloseTimer();
		}

		function getInnerSubmenuState(item) {
			return innerSubmenuMap.get(item) || null;
		}

		function isPanelActive(item) {
			const state = getInnerSubmenuState(item);

			return !!state && state.panel.classList.contains('is-mega-menu-active');
		}

		function syncInnerSubmenuState(nextActiveItem) {
			activeInnerItem = nextActiveItem;

			innerSubmenuItems.forEach(function ({ item, toggle, submenu }) {
				const isActive = item === nextActiveItem;

				item.classList.toggle('is-submenu-intent-active', isActive);
				toggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
				submenu.setAttribute('aria-hidden', isActive ? 'false' : 'true');
			});
		}

		function openInnerSubmenu(item) {
			if (!desktopMediaQuery.matches || !item || !isPanelActive(item)) {
				return;
			}

			clearAllTimers();
			syncInnerSubmenuState(item);
		}

		function closeInnerSubmenus() {
			clearAllTimers();

			if (!activeInnerItem && !pendingInnerItem) {
				return;
			}

			syncInnerSubmenuState(null);
		}

		function scheduleOpen(item, delay) {
			clearPendingTimers();
			pendingInnerItem = item;

			const timerCallback = function () {
				if (pendingInnerItem !== item || !isPanelActive(item)) {
					return;
				}

				syncInnerSubmenuState(item);
				pendingInnerItem = null;
				openTimerId = 0;
				switchTimerId = 0;
			};

			if (delay <= 0) {
				timerCallback();
				return;
			}

			if (activeInnerItem) {
				switchTimerId = window.setTimeout(timerCallback, delay);
				return;
			}

			openTimerId = window.setTimeout(timerCallback, delay);
		}

		function scheduleCloseActiveSubmenu() {
			if (!activeInnerItem) {
				return;
			}

			clearCloseTimer();

			const itemToClose = activeInnerItem;
			closeTimerId = window.setTimeout(function () {
				if (activeInnerItem === itemToClose) {
					closeInnerSubmenus();
				}
			}, innerSubmenuAimSettings.closeDelay);
		}

		function isPointerMovingTowardActiveSubmenu() {
			if (!activeInnerItem || !previousPointerPosition || !currentPointerPosition) {
				return false;
			}

			const activeState = getInnerSubmenuState(activeInnerItem);

			if (!activeState) {
				return false;
			}

			const submenuRect = activeState.submenu.getBoundingClientRect();

			if (!submenuRect.width && !submenuRect.height) {
				return false;
			}

			const movingRight = currentPointerPosition.x > previousPointerPosition.x;
			const withinVerticalBand = currentPointerPosition.y >= submenuRect.top - innerSubmenuAimSettings.corridorPadding
				&& currentPointerPosition.y <= submenuRect.bottom + innerSubmenuAimSettings.corridorPadding;
			const beforeSubmenu = currentPointerPosition.x <= submenuRect.left + innerSubmenuAimSettings.corridorPadding;

			return movingRight && withinVerticalBand && beforeSubmenu;
		}

		function keepActiveSubmenuOpen() {
			clearCloseTimer();
			clearPendingTimers();

			if (activeInnerItem) {
				syncInnerSubmenuState(activeInnerItem);
			}
		}

		function handleInnerWrapperMouseMove(event) {
			if (!desktopMediaQuery.matches) {
				return;
			}

			previousPointerPosition = currentPointerPosition;
			currentPointerPosition = {
				x: event.clientX,
				y: event.clientY,
			};
		}

		function handleInnerItemMouseEnter(event) {
			const item = event.currentTarget;

			if (!desktopMediaQuery.matches || !isPanelActive(item)) {
				return;
			}

			clearCloseTimer();

			if (activeInnerItem === item) {
				keepActiveSubmenuOpen();
				return;
			}

			if (activeInnerItem) {
				scheduleOpen(
					item,
					isPointerMovingTowardActiveSubmenu()
						? innerSubmenuAimSettings.protectedSwitchDelay
						: innerSubmenuAimSettings.switchDelay
				);
				return;
			}

			scheduleOpen(item, innerSubmenuAimSettings.openDelay);
		}

		function handleInnerItemMouseLeave(event) {
			const item = event.currentTarget;
			const relatedTarget = event.relatedTarget;

			if (!desktopMediaQuery.matches || !isPanelActive(item)) {
				return;
			}

			if (relatedTarget instanceof Node && item.contains(relatedTarget)) {
				return;
			}

			if (pendingInnerItem === item) {
				clearPendingTimers();

				if (activeInnerItem && activeInnerItem !== item) {
					scheduleCloseActiveSubmenu();
				}
			}

			if (activeInnerItem === item) {
				scheduleCloseActiveSubmenu();
			}
		}

		function handleInnerSubmenuMouseEnter(event) {
			const item = event.currentTarget.closest('.wp-block-navigation-item.has-child');

			if (!desktopMediaQuery.matches || activeInnerItem !== item) {
				return;
			}

			keepActiveSubmenuOpen();
		}

		function handleInnerSubmenuMouseLeave(event) {
			const item = event.currentTarget.closest('.wp-block-navigation-item.has-child');
			const relatedTarget = event.relatedTarget;

			if (!desktopMediaQuery.matches || activeInnerItem !== item) {
				return;
			}

			if (relatedTarget instanceof Node && item && item.contains(relatedTarget)) {
				return;
			}

			scheduleCloseActiveSubmenu();
		}

		function handleInnerItemFocusIn(event) {
			const item = event.currentTarget;

			if (!isPanelActive(item)) {
				return;
			}

			openInnerSubmenu(item);
		}

		function handleInnerItemFocusOut(event) {
			const item = event.currentTarget;

			if (!isPanelActive(item)) {
				return;
			}

			window.setTimeout(function () {
				if (activeInnerItem === item && !item.contains(document.activeElement)) {
					closeInnerSubmenus();
				}
			}, 0);
		}

		wrapper.addEventListener('mousemove', handleInnerWrapperMouseMove);

		innerSubmenuItems.forEach(function ({ item, submenu, toggle }) {
			item.classList.remove('is-submenu-intent-active');
			item.removeAttribute('data-wp-on--mouseenter');
			item.removeAttribute('data-wp-on--mouseleave');
			item.removeAttribute('data-wp-on--focusout');
			toggle.setAttribute('aria-expanded', 'false');
			submenu.setAttribute('aria-hidden', 'true');

			item.addEventListener('mouseenter', handleInnerItemMouseEnter);
			item.addEventListener('mouseleave', handleInnerItemMouseLeave);
			item.addEventListener('focusin', handleInnerItemFocusIn);
			item.addEventListener('focusout', handleInnerItemFocusOut);
			submenu.addEventListener('mouseenter', handleInnerSubmenuMouseEnter);
			submenu.addEventListener('mouseleave', handleInnerSubmenuMouseLeave);
		});

		return closeInnerSubmenus;
	}

	function initMegaMenu() {
		const pageTop = document.getElementById('page-top');

		if (!pageTop) {
			return;
		}

		const searchWrapper = pageTop.querySelector('.search-wrapper');
		const searchBlock = pageTop.querySelector('.wp-block-search');

		if (searchWrapper && searchBlock) {
			searchWrapper.addEventListener('click', function () {
				searchBlock.classList.toggle('is-search-open');
				searchBlock.querySelector('input[type="search"]')?.focus();
			});
		}

		const wrapper = pageTop.querySelector('.mega-menu-wrapper');

		if (!wrapper) {
			return;
		}

		const triggerItems = Array.from(pageTop.querySelectorAll('.wp-block-navigation > .wp-block-navigation__responsive-container .wp-block-navigation__container > .has-mega-menu, .wp-block-navigation > .wp-block-navigation__container > .has-mega-menu'));
		const panels = Array.from(wrapper.querySelectorAll('.mega-menu'));

		if (!triggerItems.length || !panels.length) {
			return;
		}

		const panelMap = new Map();
		const triggerMap = new Map();
		let activeKey = null;

		panels.forEach((panel) => {
			const key = getMenuKey(panel.classList, 'mega-menu-panel--');

			if (!key) {
				return;
			}

			if (!panel.id) {
				panel.id = 'mega-menu-panel-' + key;
			}

			panelMap.set(key, panel);
		});

		triggerItems.forEach((triggerItem) => {
			const key = getMenuKey(triggerItem.classList, 'menu-key-');
			const triggerLink = triggerItem.querySelector('.wp-block-navigation-item__content');

			if (!key || !triggerLink || !panelMap.has(key)) {
				return;
			}

			triggerMap.set(key, triggerItem);
			triggerLink.setAttribute('aria-haspopup', 'true');
			triggerLink.setAttribute('aria-expanded', 'false');
			triggerLink.setAttribute('aria-controls', panelMap.get(key).id);
		});

		if (!triggerMap.size) {
			return;
		}

		wrapper.classList.add('mega-menu-enhanced');
		const closeInnerSubmenus = initInnerSubmenuAim(wrapper);

		function syncExpandedState(isExpanded) {
			triggerMap.forEach((triggerItem, key) => {
				const triggerLink = triggerItem.querySelector('.wp-block-navigation-item__content');

				if (!triggerLink) {
					return;
				}

				triggerLink.setAttribute('aria-expanded', isExpanded && key === activeKey ? 'true' : 'false');
			});
		}

		function closeMenu() {
			closeInnerSubmenus();
			activeKey = null;
			pageTop.classList.remove('is-mega-menu-open');
			wrapper.classList.remove('is-mega-menu-open');

			triggerMap.forEach((triggerItem) => {
				triggerItem.classList.remove('is-mega-menu-active');
			});

			panelMap.forEach((panel) => {
				panel.classList.remove('is-mega-menu-active');
			});

			syncExpandedState(false);
		}

		function openMenu(key) {
			if (!desktopMediaQuery.matches || !triggerMap.has(key) || !panelMap.has(key)) {
				return;
			}

			if (activeKey && activeKey !== key) {
				closeInnerSubmenus();
			}

			activeKey = key;
			pageTop.classList.add('is-mega-menu-open');
			wrapper.classList.add('is-mega-menu-open');

			triggerMap.forEach((triggerItem, triggerKey) => {
				triggerItem.classList.toggle('is-mega-menu-active', triggerKey === key);
			});

			panelMap.forEach((panel, panelKey) => {
				panel.classList.toggle('is-mega-menu-active', panelKey === key);
			});

			syncExpandedState(true);
		}

		function maybePreventPlaceholderNavigation(event, triggerItem) {
			const triggerLink = triggerItem.querySelector('.wp-block-navigation-item__content');
			const href = triggerLink?.getAttribute('href') || '';

			if (!href || href === '#') {
				event.preventDefault();
			}
		}

		triggerMap.forEach((triggerItem, key) => {
			triggerItem.addEventListener('mouseenter', function () {
				openMenu(key);
			});

			triggerItem.addEventListener('focusin', function () {
				openMenu(key);
			});

			triggerItem.addEventListener('click', function (event) {
				if (!desktopMediaQuery.matches) {
					return;
				}

				maybePreventPlaceholderNavigation(event, triggerItem);

				if (activeKey === key) {
					closeMenu();
					return;
				}

				openMenu(key);
			});
		});

		pageTop.addEventListener('mouseleave', function (event) {
			if (!desktopMediaQuery.matches) {
				return;
			}

			const relatedTarget = event.relatedTarget;

			if (relatedTarget instanceof Node && pageTop.contains(relatedTarget)) {
				return;
			}

			closeMenu();
		});

		pageTop.addEventListener('focusout', function () {
			if (!desktopMediaQuery.matches) {
				return;
			}

			window.setTimeout(function () {
				if (!pageTop.contains(document.activeElement)) {
					closeMenu();
				}
			}, 0);
		});

		document.addEventListener('click', function (event) {
			if (!desktopMediaQuery.matches) {
				return;
			}

			if (event.target instanceof Node && !pageTop.contains(event.target)) {
				closeMenu();
			}
		});

		document.addEventListener('keydown', function (event) {
			if (event.key !== 'Escape') {
				return;
			}

			closeMenu();
		});

		const handleMediaChange = function (mediaQueryEvent) {
			if (!mediaQueryEvent.matches) {
				closeMenu();
			}
		};

		if (typeof desktopMediaQuery.addEventListener === 'function') {
			desktopMediaQuery.addEventListener('change', handleMediaChange);
		} else {
			desktopMediaQuery.addListener(handleMediaChange);
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initMegaMenu, { once: true });
	} else {
		initMegaMenu();
	}
})();